import { render, staticRenderFns } from "./OrderServiceDetails.vue?vue&type=template&id=630d95ee&scoped=true&"
import script from "./OrderServiceDetails.vue?vue&type=script&lang=js&"
export * from "./OrderServiceDetails.vue?vue&type=script&lang=js&"
import style0 from "./OrderServiceDetails.vue?vue&type=style&index=0&id=630d95ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630d95ee",
  null
  
)

export default component.exports